import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { Col, Form as BsForm, Row } from 'react-bootstrap';

// W-0651 — Form Formik: Edit1 (código atual, readonly) + Edit2 (novo código) + Edit4 (observação).
// Paridade Ualteracodigoconta.pas. Os campos são controlados pelo Formik do index.js.
const FormAlteracao = ({ contaSelecionada, disabled }) => {
  return (
    <Row className="mt-3">
      <Col xs={12} md={3}>
        <BsForm.Label className="small mb-1">Código Atual</BsForm.Label>
        <BsForm.Control
          type="text"
          value={contaSelecionada ? contaSelecionada.codigo_conta : ''}
          readOnly
          disabled
        />
        {contaSelecionada && (
          <div className="text-secondary small mt-1">
            {contaSelecionada.apelido_conta}
          </div>
        )}
      </Col>
      <Col xs={12} md={3}>
        <BsForm.Label className="small mb-1">Novo Código</BsForm.Label>
        <Field
          name="codigoContaNovo"
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={10}
          className="form-control"
          disabled={disabled || !contaSelecionada}
        />
        <ErrorMessage
          name="codigoContaNovo"
          component="div"
          className="text-danger small mt-1"
        />
      </Col>
      <Col xs={12} md={6}>
        <BsForm.Label className="small mb-1">Observação</BsForm.Label>
        <Field
          as="textarea"
          name="observacao"
          rows={2}
          maxLength={255}
          className="form-control"
          disabled={disabled || !contaSelecionada}
        />
        <ErrorMessage
          name="observacao"
          component="div"
          className="text-danger small mt-1"
        />
      </Col>
    </Row>
  );
};

export default FormAlteracao;
